/**
 * Rolagem do trilho de mensagens (`components/messages/messages.vue`) —
 * funções PURAS sobre o container que rola, compartilhadas pelo índice de
 * mensagens (`rolarAteMensagem`), pelo índice de artefatos inline
 * (`rolarAteArtefato`) e pela pergunta nova do turno
 * (`scrollNewUserMessageToTop`). Uma conta só: as três rolagens alinham o
 * alvo do mesmo jeito, e mudar o respiro ou a suavização num lugar muda nos
 * outros.
 *
 * ⚠️ Nada aqui chama `scrollIntoView`: ele resolve o alinhamento subindo a
 * cadeia INTEIRA de ancestrais roláveis e mexe no scroll da página (foi o que
 * fazia o composer subir — ver "O composer fica no rodapé" no CLAUDE.md do
 * módulo). Só o CONTAINER rola, por `scrollTo`/`scrollTop`.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila).
 */

// Ao alinhar um alvo pelo topo, ele fica a esta distância do topo do
// container — colado no pixel 0 lê como cortado.
export const RESPIRO_PADRAO = 24

/**
 * O primeiro descendente de `el` cujo `data-<attr>` é `valor` (comparado como
 * string — ids numéricos chegam como número). `null` sem container, sem valor
 * ou sem alvo.
 */
export function encontrarPorDataAttr(el, attr, valor) {
  if (!el || !attr || valor === undefined || valor === null || valor === '') return null
  const esperado = String(valor)
  return (
    Array.prototype.find.call(el.querySelectorAll('[data-' + attr + ']'), function (no) {
      return no.getAttribute('data-' + attr) === esperado
    }) || null
  )
}

/**
 * O `scrollTop` que põe o topo de `alvo` a `respiro` px do topo de `el`.
 * Posição por `getBoundingClientRect` + `scrollTop`, não por `offsetTop` —
 * rects não dependem de quem é o `offsetParent`. Nunca negativo; o browser
 * clampa sozinho o teto (conteúdo curto).
 */
export function scrollTopParaAlinhar(el, alvo, respiro) {
  const folga = typeof respiro === 'number' ? respiro : RESPIRO_PADRAO
  const topo =
    alvo.getBoundingClientRect().top - el.getBoundingClientRect().top + el.scrollTop - folga
  return Math.max(0, topo)
}

/**
 * Rola o CONTAINER até `destino`. `suave` liga o `behavior: 'smooth'` (quem
 * pediu menos movimento passa `false`). jsdom e browsers antigos não têm
 * `Element.scrollTo` — aí é atribuição direta.
 */
export function rolarContainerAte(el, destino, { suave = true } = {}) {
  if (!el) return
  if (typeof el.scrollTo === 'function') {
    el.scrollTo({ top: destino, behavior: suave ? 'smooth' : 'auto' })
    return
  }
  el.scrollTop = destino
}
